import { Stack, styled } from '@mui/material'
import { Card } from 'components'

export const BlendRatioContainer = styled(Card)`
  padding: 16px;
`

export const BlendRatioItems = styled(Stack)`
  padding-top: 16px;
  gap: 4px;
`

export const BlendRatioItem = styled(Stack)`
  height: 48px;
  width: 100%;
  padding: 0 18px;
  background-color: ${({ theme }) => theme.palette.customGrey.five};
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
  flex-direction: row;
  align-items: center;
`
